define('editor/edit/contexts/export',['jquery', 'plugins/dialog', 'knockout', 'durandal/system', 'durandal/composition', 'durandal/activator', 'plugins/http'], function ($, dialog, ko, system, composition, activator, http) {
    var viewmodel = function () {
        var self = this;

        self.block = null;
        self.host = null;
        self.content = ko.observable();
        self.fadeIn = "inner animated fadeInRight";
        self.fadeOut = "inner animated fadeOutRight";
        self.removeDelay = 1000;
        self.theDialog = null;
        self.screenshotExportOpen = false;

        self.activate = function (editorMap) {
            self.editorMap = editorMap;
            self.editorMapId = editorMap.id;
        };

        self.exportScreenshot = function () {
            var body = $('body');
            self.block = $('<div id="mapforge-custom-dialog"></div>').appendTo(body);
            self.host = $('<div class="' + self.fadeIn + '"></div>').appendTo(self.block);

            system.acquire('editor/export/index')
                .then(function (instance) {
                    var dialogActivator = activator.create(),
                        moduleInstance = system.resolveObject(instance),
                        activationData = [self.editorMap.id];
                    self.screenshotExportOpen = true;

                    dialogActivator.activateItem(moduleInstance, activationData)
                        .then(function () {
                            var settings = {
                                model: moduleInstance,
                                activate: false,
                                transition: false
                            };

                            self.theDialog = {
                                close: function () {
                                    dialogActivator.deactivateItem(moduleInstance, true);
                                    self.screenshotExportOpen = false;
                                }
                            };

                            composition.compose(self.host.get(0), settings);
                        });
                });
        };

        self.exportKml = function () {
            window.location = "/api/shapes/export/" + self.editorMapId;
        };

        self.deactivate = function () {
            if (self.screenshotExportOpen === true) {
                self.host.attr('class', self.fadeOut);
            }            

            setTimeout(function () {
                self.theDialog.close();
                self.host.remove();
                self.block.remove();
            }, self.removeDelay);
        };
    };

    return viewmodel;
});

